<template>
  <div id="app">
    <div id="wrapper">
      <NavBar ref="NavBar" />
      <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
      <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
      <transition name="router-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in" :duration="1000">
        <component v-bind:is="currentComponent" :introComponent=introComponent @introChangeComponent="introChangeComponent($event)" @changeComponent="changeComponent($event)" @changeNavBarColor="changeNavBarColor($event)"></component>
      </transition>
      <!-- <Intro /> -->
      <!-- <Simulation /> -->
    </div>
  </div>
</template>

<script>
import Intro from './components/Intro.vue';
import Simulation from './components/Simulation.vue';
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    'Intro': Intro,
    'Simulation': Simulation,
    'NavBar': NavBar
    // "Intro": Intro, 
    // Simulation
  },
  data() {
    return {
      // sectionName: '',
      currentComponent: "Intro",
      introComponent: ''
    }
  },
  methods: {
    changeComponent($event) {
      //  alert(this.sectionName);
      console.log($event);
      this.currentComponent = $event;
      // window.scrollTo(0, 0);
      // this.sectionName = $event;
    },
    introChangeComponent($event) {
      this.currentComponent = 'Simulation';
      this.introComponent = $event;
      console.log(this.introComponent);
    },
    changeNavBarColor($event){
      if ($event == 1) {
        this.$refs.NavBar.roundColor();
      }
      if ($event == 2) {
        this.$refs.NavBar.flatColor();
      }
      if ($event == 3) {
        this.$refs.NavBar.hollowColor();
      }
    }
  },
  mounted() {
    // window.scrollTo(0, 0);
  }
}
</script>

<style>
  @import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.css";
  @import "https://use.typekit.net/tla6fmr.css";

  /* .fade-transition {
    transition: opacity 5000s ease;
  }

  .fade-enter, .fuck-this-leave {
    opacity: 0;
  } */

  /* .fade-enter-to, .fade-leave {
    opacity: 0;
  } */


  /* .fade-enter-active, .fade-leave-active {
    opacity: 0;
  }

  .fade-enter-to, .fade-leave {
    opacity: 1;
  } */
  /* .page {
    position: absolute;
    width: inherit;
  } */

  html, body {
    padding: 0;
    margin: 0;
    background-color: #F0F4F8;
    /* height: 100%; */
    /* overflow: hidden; */
    color: #212121;
    cursor: crosshair;
  }

  body::-webkit-scrollbar {
    display: none;
  }

  #app {
    /* position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0; */
    /* overflow: hidden; */
  }

  #wrapper {
    padding-top: 18vh;
    margin-bottom: 60vh;
    position: relative;
  }

  h1 {
    font-family: soleil, sans-serif;
    text-transform: uppercase;
    line-height: 74px;
    font-size: 74px;
    margin: 0;
    user-select: none;
  }

  h3 {
    font-family: odisseia, sans-serif;
    font-weight: 600;
    font-size: 20px;
    margin: 0;
    user-select: none;
  }

  h2 {
    font-family: soleil, sans-serif;
    font-weight: 800;
    margin: 0;
    font-size: 30px;
    line-height: 30px;
    margin-bottom: 32px;
    color: #2D7BE5;
  }

  h4 {
    margin: 0;
    font-family: odisseia, sans-serif;
    font-weight: 600;
    font-size: 16px;
    opacity: .5;
  }

  p {
    font-family: soleil, sans-serif;
    font-size: 22px;
    line-height: 36px;
    margin: 20px 0px;
    width: auto;
    /* font-weight: 600; */
  }

  .button-header {
    position: absolute;
    bottom: calc(0px - 40vh + 45px);
  }

  .button-wrapper {
    position: absolute;
    display: flex;
    justify-content: space-between;
    /* width: calc(100% - 30vw); */
    bottom: calc(0px - 40vh - 30px);
  }
  
  .button {
    /* width: 20%; */
    min-width: 200px;
    margin-right: 40px;
    height: 60px;
    /* position: absolute; */
    /* background-color: #2D7BE5; */
    box-shadow: 0px 0px 0px 2px #212121;
    transition: box-shadow .3s ease-in-out, background-color .3s ease-in-out;
    font-family: odisseia, sans-serif;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
    line-height: 60px;
    box-sizing: border-box;
  }

  .button:hover {
    /* box-shadow: 0px 0px 0px 5px #212121; */
    background-color: #2D7BE5;
    cursor: pointer;
  }

  .button:hover.round {
      /* box-shadow: 0px 0px 0px 5px #212121; */
      background-color: #2D7BE5;
      cursor: pointer;
  }

  .button:hover.flat {
      /* box-shadow: 0px 0px 0px 5px #212121; */
      background-color: #459300;
      cursor: pointer;
  }

  .button:hover.hollow {
      /* box-shadow: 0px 0px 0px 5px #212121; */
      background-color: #D2841A;
      cursor: pointer;
  }

</style>
